import { useEffect } from 'react';
import { useSettings } from 'src/@core/hooks/useSettings';
import { DashboardViewMode } from './customDashboard';

interface DashModeWatcherProps {
  viewMode: DashboardViewMode;
}

const DashModeWatcher: React.FC<DashModeWatcherProps> = ({ viewMode }) => {
  const { settings, saveSettings } = useSettings();

  useEffect(() => {
    if (viewMode === 'view' && settings.unlockDashboardLayout) {
      saveSettings({ ...settings, unlockDashboardLayout: false });
    }

    return () => {
      if (settings.unlockDashboardLayout) {
        saveSettings({ ...settings, unlockDashboardLayout: false });
      }
    };
  }, [viewMode, settings.unlockDashboardLayout, saveSettings, settings]);

  return null;
};

export default DashModeWatcher;
